import * as React from "react"
import {Box, Grid, Typography} from "@mui/material";
import {ImageSeeker} from "@ui-seeker/core";
import ProductPagesDetailsImagesModal from "./Modal";
import {useSignal} from "@preact/signals-react";


export default function ProductPagesDetailsModalImagesContent({ images=[], data, showTitle=true, isRichContent=false }) {
    const openModal = useSignal(false)
    const haveImages = images.length > 0

    return <Grid container spacing={2}>
        {!!showTitle && <Grid item xs={12}>
            <Typography variant="subtitle2">
                Images: { !haveImages && "--" }
            </Typography>
        </Grid>}

        { !!haveImages && <Grid item xs={12} sx={{ display: 'flex', gap: .5, cursor: 'pointer', flexWrap: 'wrap' }} onClick={() => openModal.value = true}>
            { images.map(({ position, multimediaURL }) => <Box key={position}>
                <ImageSeeker src={multimediaURL} sx={{ height: 50 }} />
            </Box>) }
        </Grid> }

        <ProductPagesDetailsImagesModal
            isOpen={openModal.value}
            controller={() => openModal.value = false}
            data={data}
            isRichContent={isRichContent}
        />
    </Grid>
}